import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Globals } from '../../globals';
@Injectable({
  providedIn: 'root',
})
export class jwtMqttService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);


  execute(code: string, sendConfirmation = false) {
    return this.http.post(this.globals.apiRoot + '/jwtMqtt/execute', {
      code,
      sendConfirmation,
    });
  }
}
